import { Controller } from "@hotwired/stimulus"

// The simulator's "Me localiser" (simulators/_location): asks the browser where the gallerist is,
// rounds the position to about a kilometre and sends it. The form stays hidden without the
// Geolocation API; refused or failed, a message points to the postal code field.
export default class extends Controller {
  static targets = ["form", "latitude", "longitude", "button", "error", "postalCode"]
  static values = { denied: String, failed: String }

  declare readonly formTarget: HTMLFormElement
  declare readonly latitudeTarget: HTMLInputElement
  declare readonly longitudeTarget: HTMLInputElement
  declare readonly buttonTarget: HTMLButtonElement
  declare readonly errorTarget: HTMLElement
  declare readonly postalCodeTarget: HTMLInputElement
  declare readonly deniedValue: string
  declare readonly failedValue: string

  connect() {
    if ("geolocation" in navigator) this.formTarget.hidden = false
  }

  locate() {
    this.errorTarget.textContent = ""
    this.busy(true)
    navigator.geolocation.getCurrentPosition(
      ({ coords }) => {
        this.latitudeTarget.value = coords.latitude.toFixed(2)
        this.longitudeTarget.value = coords.longitude.toFixed(2)
        this.formTarget.requestSubmit()
      },
      error => {
        this.busy(false)
        this.errorTarget.textContent = error.code === error.PERMISSION_DENIED ? this.deniedValue : this.failedValue
        this.postalCodeTarget.focus()
      },
      { timeout: 10000, maximumAge: 600000 }
    )
  }

  private busy(busy: boolean) {
    this.buttonTarget.disabled = busy
    if (busy) this.buttonTarget.setAttribute("aria-busy", "true")
    else this.buttonTarget.removeAttribute("aria-busy")
  }
}
